var getBuiltIn = require('../internals/get-built-in');

module.exports = getBuiltIn('navigator', 'userAgent') || '';



//////////////////
// WEBPACK FOOTER
// ./~/canvg/~/core-js/internals/engine-user-agent.js
// module id = 403
// module chunks = 0